import { Component, OnInit, Output, Input, EventEmitter, ViewChild } from '@angular/core';
import { ImageContentItem } from '../../../services/app/content/models/content-items/image-content-item.model';
import { ModalService } from '../../../services/modal/modal.service';
import { ImageUploadService } from 'app/shared/services/image-upload/image-upload.service';
import { ImageService } from '../../../services/image/image.service';
import { LoaderButton } from 'app/shared/components/loader-button/loader-button.component';
import { ContentImageCropperComponent } from 'app/shared/components/content-image-cropper/content-image-cropper.component';
import { ImageLibraryCropperModalComponent } from '../../image-library-cropper-modal/image-library-cropper-modal.component';

@Component({
  selector: 'tog-content-editor-image-modal',
  templateUrl: './content-editor-image-modal.component.html',
  styleUrls: ['./content-editor-image-modal.component.scss']
})
export class ContentEditorImageModalComponent implements OnInit {
  hasImage: boolean = false;
  editMode: boolean = false;
  imageContentItem: ImageContentItem;

  @Input() app: string;
  @Output() imageChanged: EventEmitter<{ image: ImageContentItem, isNew: boolean }> = new EventEmitter<{ image: ImageContentItem, isNew: boolean }>();

  @ViewChild('imageEditor') imageEditor: ImageLibraryCropperModalComponent;

  constructor(public modal: ModalService, public imageService: ImageService,
    public imageUploadService: ImageUploadService) { }

  ngOnInit() { }

  show(image: ImageContentItem = null) {
    this.imageContentItem = image;
    if (image) {
      this.hasImage = true;
      this.editMode = true;

      // Since there could be multiple images selected, need to overwrite default functionality which is to
      // select the image when the library loads and call the function manually
      this.imageService.setImageURLToBeCropped(image.imageUrl, 'image-library-cropper');
      this.imageEditor.library.attemptToSelectOriginalImage();
    } else {
      this.editMode = false;
    }
    setTimeout(() => { this.imageEditor.show(); });
  }

  imageSelected() {
    this.hasImage = true;
  }

  onImageChanged() {
    // Upload image and either edit the content item or emit a new one
    let image = this.imageService.getCroppedImage('image-library-cropper');
    this.imageUploadService.uploadCroppedImage(this.app, image, this.imageService.getOriginalName('image-library-cropper'))
    .then(imageUrl => {
      let isNew = false;
      if (this.imageContentItem) this.imageContentItem.imageUrl = imageUrl;
      else {
        this.imageContentItem = new ImageContentItem({ url: imageUrl });
        isNew = true;
      }
      this.imageChanged.emit({ image: this.imageContentItem, isNew: isNew });
      this.imageEditor.saveImageButton.setConfirmed();
      this.modal.hide(500);
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/content-editor/content-editor-image-modal/content-editor-image-modal.component.ts